import { render, staticRenderFns } from "./dragGrid.vue?vue&type=template&id=d78901c2&"
import script from "./dragGrid.vue?vue&type=script&lang=js&"
export * from "./dragGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/dragGrid.vue"
export default component.exports